import { variables } from '@xingternal/malt-predicates';

export const listeners = [];

let matchedMedia = null;
const breakpoints = Object.keys(variables)
  .filter(item => item.startsWith('breakpoint') && item.endsWith('Range'))
  .map(item => ({
    name: item.slice(10, -5).toLowerCase(),
    query: variables[item],
  }));

/** @private */
export function init(matchMedia) {
  if (typeof matchMedia === 'function') {
    const matchedBreakpoint = breakpoints.find(
      ({ query }) => matchMedia(query).matches
    );
    matchedMedia = matchedBreakpoint ? matchedBreakpoint.name : 'handheld';
  } else {
    matchedMedia = 'handheld';
  }

  if (typeof matchMedia === 'function') {
    breakpoints.forEach(({ name, query }) => {
      matchMedia(query).addListener(({ matches }) => {
        if (matches) {
          matchedMedia = name;
          listeners.forEach(listener => listener(name));
        }
      });
    });
  }
}

init(typeof window !== 'undefined' ? window.matchMedia : null);

export default function getMatchedMedia() {
  return matchedMedia;
}
